import { all } from 'redux-saga/effects';
import { compatibilitySaga } from './compatibility';

function* deviceSaga() {
    yield all([compatibilitySaga()]);
}

export { deviceSaga };
